(function () {
  'use strict';

  if (window.FAEnquiryForms) {
    window.FAEnquiryForms.init(document);
    return;
  }

  var icons = {
    website: '<svg viewBox="0 0 24 24" role="presentation"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.92 6h-3.06a15.7 15.7 0 0 0-1.38-3.2A8.06 8.06 0 0 1 18.92 8ZM12 4c.83 1.01 1.49 2.37 1.82 4h-3.64C10.51 6.37 11.17 5.01 12 4ZM4.26 14a7.8 7.8 0 0 1 0-4h3.4a17.2 17.2 0 0 0 0 4h-3.4Zm.82 2h3.06c.3 1.17.76 2.25 1.38 3.2A8.06 8.06 0 0 1 5.08 16Zm3.06-8H5.08a8.06 8.06 0 0 1 4.44-3.2A15.7 15.7 0 0 0 8.14 8ZM12 20c-.83-1.01-1.49-2.37-1.82-4h3.64c-.33 1.63-.99 2.99-1.82 4Zm2.16-6H9.84a14.7 14.7 0 0 1 0-4h4.32a14.7 14.7 0 0 1 0 4Zm.32 5.2c.62-.95 1.08-2.03 1.38-3.2h3.06a8.06 8.06 0 0 1-4.44 3.2ZM16.34 14a17.2 17.2 0 0 0 0-4h3.4a7.8 7.8 0 0 1 0 4h-3.4Z"/></svg>',
    youtube: '<svg viewBox="0 0 24 24" role="presentation"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z"/></svg>',
    spotify: '<svg viewBox="0 0 24 24" role="presentation"><path d="M12 1.8a10.2 10.2 0 1 0 0 20.4A10.2 10.2 0 0 0 12 1.8Zm4.68 14.7a.64.64 0 0 1-.88.21c-2.4-1.47-5.42-1.8-8.98-.98a.64.64 0 1 1-.29-1.25c3.9-.9 7.24-.52 9.94 1.13.3.18.4.58.21.88Zm1.25-2.78a.8.8 0 0 1-1.1.26c-2.75-1.69-6.94-2.18-10.19-1.19a.8.8 0 1 1-.47-1.54c3.72-1.13 8.34-.59 11.5 1.35.38.23.5.73.26 1.12Zm.11-2.9C14.75 8.86 9.3 8.67 6.16 9.63a.96.96 0 1 1-.56-1.84c3.6-1.1 9.63-.87 13.43 1.39a.96.96 0 0 1-.99 1.65Z"/></svg>',
    soundcloud: '<svg viewBox="0 0 24 24" role="presentation"><path d="M1.1 13.1c-.3 0-.55.93-.55 2.08s.25 2.08.55 2.08.55-.93.55-2.08-.25-2.08-.55-2.08Zm2.18-1.31c-.39 0-.7 1.52-.7 3.39s.31 3.39.7 3.39.7-1.52.7-3.39-.31-3.39-.7-3.39Zm2.42-1.06c-.48 0-.87 2-.87 4.45s.39 4.45.87 4.45.87-2 .87-4.45-.39-4.45-.87-4.45Zm12.13 1.11a4.35 4.35 0 0 0-1.62.31 6.28 6.28 0 0 0-6.1-5.01c-.8 0-1.58.16-2.28.44-.28.11-.35.23-.35.45v11.11c0 .24.18.44.42.47h9.93a3.9 3.9 0 0 0 0-7.78Z"/></svg>',
    apple: '<svg viewBox="0 0 24 24" role="presentation"><path d="M19.4 3.2 9.2 5.3v11.18a3.9 3.9 0 0 0-1.7-.38c-1.93 0-3.5 1.25-3.5 2.8s1.57 2.8 3.5 2.8 3.5-1.25 3.5-2.8V9.1l6.6-1.36v6.34a3.9 3.9 0 0 0-1.7-.38c-1.93 0-3.5 1.25-3.5 2.8s1.57 2.8 3.5 2.8 3.5-1.25 3.5-2.8V3.2Z"/></svg>',
    instagram: '<svg viewBox="0 0 24 24" role="presentation"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7Zm10.5 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" role="presentation"><path d="M15.5 2h-3v13.3a3.2 3.2 0 1 1-2.7-3.16v-3A6.2 6.2 0 1 0 15.5 15V8.24A7.7 7.7 0 0 0 20 9.68v-3a4.7 4.7 0 0 1-4.5-4.68Z"/></svg>',
    facebook: '<svg viewBox="0 0 24 24" role="presentation"><path d="M14 8.5V6.8c0-.8.53-1 1-1h2.9V2.15L14.7 2C11.55 2 10 3.9 10 6.45V8.5H7V12h3v10h4V12h3.3l.55-3.5H14Z"/></svg>',
    x: '<svg viewBox="0 0 24 24" role="presentation"><path d="M18.9 2H22l-6.8 7.77L23.2 22h-6.27l-4.9-6.42L6.4 22H3.3l7.28-8.32L2.9 2h6.43l4.43 5.86L18.9 2Zm-1.1 17.85h1.72L8.4 4.04H6.56L17.8 19.85Z"/></svg>',
    bandcamp: '<svg viewBox="0 0 24 24" role="presentation"><path d="M7.1 5h14L16.9 19h-14L7.1 5Z"/></svg>'
  };

  function cleanPhone(value) {
    return value.trim().replace(/[\s().-]/g, '');
  }

  function isValidPhone(value) {
    if (!value.trim()) return true;
    return /^(?:\+[1-9]\d+|0\d+)$/.test(cleanPhone(value));
  }

  function platformFor(value) {
    var lower = value.toLowerCase();
    if (lower.indexOf('youtube.com') !== -1 || lower.indexOf('youtu.be') !== -1) return 'youtube';
    if (lower.indexOf('spotify.com') !== -1) return 'spotify';
    if (lower.indexOf('soundcloud.com') !== -1) return 'soundcloud';
    if (lower.indexOf('music.apple.com') !== -1) return 'apple';
    if (lower.indexOf('instagram.com') !== -1) return 'instagram';
    if (lower.indexOf('tiktok.com') !== -1) return 'tiktok';
    if (lower.indexOf('facebook.com') !== -1 || lower.indexOf('fb.com') !== -1) return 'facebook';
    if (lower.indexOf('twitter.com') !== -1 || lower.indexOf('x.com') !== -1) return 'x';
    if (lower.indexOf('bandcamp.com') !== -1) return 'bandcamp';
    return 'website';
  }

  function updateSocialIcon(input) {
    var row = input.closest('[data-social-row]');
    var icon = row && row.querySelector('[data-social-icon]');
    if (!icon) return;
    var platform = platformFor(input.value);
    icon.dataset.platform = platform;
    icon.innerHTML = icons[platform];
  }

  function normalizeUrl(input) {
    var value = input.value.trim();
    if (value && !/^[a-z][a-z\d+.-]*:/i.test(value) && value.indexOf('.') !== -1) {
      input.value = 'https://' + value;
    }
    updateSocialIcon(input);
  }

  function addSocialRow(group, form) {
    var list = group.querySelector('[data-social-list]');
    var button = group.querySelector('[data-add-social-link]');
    var rowCount = list.querySelectorAll('[data-social-row]').length;
    if (rowCount >= 6) return;
    var count = Number(group.dataset.socialCount || rowCount) + 1;
    group.dataset.socialCount = String(count);

    var row = document.createElement('div');
    row.className = 'enquiry-form__social-row';
    row.setAttribute('data-social-row', '');

    var icon = document.createElement('span');
    icon.className = 'enquiry-form__social-icon';
    icon.setAttribute('data-social-icon', '');
    icon.setAttribute('data-platform', 'website');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = icons.website;

    var label = document.createElement('label');
    var inputId = form.id + '-social-' + count;
    label.className = 'visually-hidden';
    label.htmlFor = inputId;
    label.textContent = 'Music or social link ' + count;

    var input = document.createElement('input');
    input.id = inputId;
    input.type = 'url';
    input.name = 'contact[Social link ' + count + ']';
    input.inputMode = 'url';
    input.placeholder = 'https://';
    input.setAttribute('data-social-input', '');
    var help = group.querySelector('.enquiry-form__help[id]');
    if (help) input.setAttribute('aria-describedby', help.id);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'enquiry-form__remove-link';
    remove.textContent = 'Remove';
    remove.setAttribute('aria-label', 'Remove social link ' + count);
    remove.addEventListener('click', function () {
      row.remove();
      button.hidden = false;
    });

    row.appendChild(icon);
    row.appendChild(label);
    row.appendChild(input);
    row.appendChild(remove);
    list.appendChild(row);
    bindSocialInput(input);
    input.focus();
    button.hidden = list.querySelectorAll('[data-social-row]').length >= 6;
  }

  function bindSocialInput(input) {
    updateSocialIcon(input);
    input.addEventListener('input', function () {
      input.removeAttribute('aria-invalid');
      input.setCustomValidity('');
      updateSocialIcon(input);
      var container = fieldErrorContainer(input);
      if (container && container.querySelector('[data-field-error="' + fieldErrorId(input) + '"]')) validateField(input, true);
    });
    input.addEventListener('invalid', function () { validateField(input, true); });
    input.addEventListener('blur', function () {
      normalizeUrl(input);
      validateField(input, true);
    });
  }

  function fieldErrorContainer(field) {
    return field.closest('.enquiry-form__field, .enquiry-form__day-selector, .enquiry-form__nested-fieldset');
  }

  function radioFields(field) {
    if (field.type !== 'radio' || !field.form) return [field];
    return Array.from(field.form.querySelectorAll('input[type="radio"]')).filter(function (radio) {
      return radio.name === field.name;
    });
  }

  function fieldErrorId(field) {
    return (radioFields(field)[0].id || 'enquiry-field') + '-error';
  }

  function fieldLabel(field) {
    if (field.type === 'radio') {
      var container = fieldErrorContainer(field);
      var label = container && container.querySelector('legend, .enquiry-form__label');
      if (label) return label.textContent.replace(/\*/g, '').trim();
    }
    var label = field.labels && field.labels[0];
    return label ? label.textContent.replace(/\*/g, '').trim() : (field.name || 'This field').replace(/^contact\[|\]$/g, '');
  }

  function focusCorrection(field) {
    field.focus({ preventScroll: true });
    field.scrollIntoView({ block: field.hasAttribute('data-form-client-error') ? 'start' : 'center', behavior: 'instant' });
  }

  function setFieldError(field, message) {
    var container = fieldErrorContainer(field);
    if (!container) return;
    var error = container.querySelector('[data-field-error="' + fieldErrorId(field) + '"]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'enquiry-form__field-error';
      error.id = fieldErrorId(field);
      error.dataset.fieldError = fieldErrorId(field);
      error.setAttribute('role', 'alert');
      container.appendChild(error);
    }
    error.textContent = message;
    radioFields(field).forEach(function (control) {
    control.setAttribute('aria-invalid', 'true');
    var describedBy = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (describedBy.indexOf(error.id) === -1) describedBy.push(error.id);
    control.setAttribute('aria-describedby', describedBy.join(' '));
    });
  }

  function clearFieldError(field) {
    var container = fieldErrorContainer(field);
    var error = container && container.querySelector('[data-field-error="' + fieldErrorId(field) + '"]');
    if (error) error.remove();
    radioFields(field).forEach(function (control) {
      control.removeAttribute('aria-invalid');
      var describedBy = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
        return id !== fieldErrorId(field);
      });
      if (describedBy.length) control.setAttribute('aria-describedby', describedBy.join(' '));
      else control.removeAttribute('aria-describedby');
    });
  }

  function validateField(field, revealError) {
    if (!field || field.disabled || field.type === 'hidden') return true;
    var message = '';

    if (field.type === 'radio') {
      var group = radioFields(field).filter(function (radio) { return !radio.disabled; });
      group.forEach(function (radio) { radio.setCustomValidity(''); });
      if (group.some(function (radio) { return radio.required; }) && !group.some(function (radio) { return radio.checked; })) {
        var labels = {
          'Type of event': 'Choose a type of event.',
          'How would you like to choose dates?': 'Choose a specific date, a range of dates, or flexible dates.',
          'Type of act': 'Choose your type of act.',
          'PAT testing': 'Select the PAT testing status of the equipment you will bring.'
        };
        message = labels[fieldLabel(field)] || 'Choose an option for ' + fieldLabel(field).toLowerCase() + '.';
        group[0].setCustomValidity(message);
        if (revealError) setFieldError(group[0], message);
        return false;
      }
      clearFieldError(field);
      return true;
    } else if (field.hasAttribute('data-contact-phone')) {
      field.setCustomValidity('');
      if (!isValidPhone(field.value)) message = 'Enter a phone number beginning with + and a country code, or 0. For example, 07123 456789.';
    } else if (field.type === 'email') {
      field.setCustomValidity('');
      if (field.validity.valueMissing) message = 'Enter your email address.';
      else if (field.validity.typeMismatch) message = 'Enter a valid email address, for example name@example.co.uk.';
    } else if (field.type === 'url') {
      field.setCustomValidity('');
      if (field.validity.valueMissing) message = 'Add at least one music or social link.';
      else if (field.validity.typeMismatch) message = 'Enter a complete web address, for example https://example.com.';
    } else {
      if (field.type !== 'checkbox' && field.type !== 'radio') field.setCustomValidity('');
      if (field.hasAttribute('data-range-end')) {
        var range = field.closest('[data-date-range]');
        var start = range && range.querySelector('[data-range-start]');
        if (start && start.value && field.value && field.value < start.value) {
          message = 'Choose an end date on or after the start date.';
        }
      }
      if (!message && field.validity.valueMissing) {
        var missingMessages = {
          'Name': 'Enter your name.',
          'Artist or band name': 'Enter your artist or band name.',
          'Main contact’s name': 'Enter the main contact’s name.',
          'Approximate guest numbers': 'Enter the approximate number of guests.',
          'Tell us what you have in mind': 'Tell us what you have in mind for your event.',
          'What days or dates can you do?': 'Tell us which days or dates you are available.',
          'Genre(s)': 'Enter your musical genres.'
        };
        message = missingMessages[fieldLabel(field)] || 'Complete ' + fieldLabel(field).toLowerCase() + '.';
      }
      if (!message && !field.validity.valid) message = field.validationMessage || 'Check this field.';
    }

    if (message) {
      field.setCustomValidity(message);
      if (revealError) setFieldError(field, message);
      return false;
    }

    field.setCustomValidity('');
    clearFieldError(field);
    return true;
  }

  function setPanelState(panel, active) {
    if (!panel) return;
    panel.hidden = !active;
    panel.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.disabled = !active;
      if (field.hasAttribute('data-required-when-active')) field.required = active;
      if (!active) {
        field.setCustomValidity('');
        clearFieldError(field);
      }
    });
  }

  function selectedValue(fields) {
    var selected = Array.prototype.find.call(fields, function (field) { return field.checked; });
    return selected ? selected.value : '';
  }

  function initOtherReveal(form, selector, panelSelector) {
    var fields = form.querySelectorAll(selector);
    var panel = form.querySelector(panelSelector);
    if (!fields.length || !panel) return;
    var update = function () { setPanelState(panel, selectedValue(fields) === 'Other'); };
    fields.forEach(function (field) { field.addEventListener('change', update); });
    update();
  }

  function localDateValue(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  function isoWeekValue(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var day = utcDate.getUTCDay() || 7;
    utcDate.setUTCDate(utcDate.getUTCDate() + 4 - day);
    var yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
    var week = Math.ceil((((utcDate - yearStart) / 86400000) + 1) / 7);
    return utcDate.getUTCFullYear() + '-W' + String(week).padStart(2, '0');
  }

  function friendlyDate(date) {
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  }

  function weekRange(value) {
    var match = /^(\d{4})-W(\d{2})$/.exec(value);
    if (!match) return '';
    var year = Number(match[1]);
    var week = Number(match[2]);
    var januaryFourth = new Date(Date.UTC(year, 0, 4));
    var monday = new Date(januaryFourth);
    monday.setUTCDate(januaryFourth.getUTCDate() - ((januaryFourth.getUTCDay() || 7) - 1) + ((week - 1) * 7));
    var sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);
    return 'Monday ' + friendlyDate(monday) + ' to Sunday ' + friendlyDate(sunday);
  }

  function initDaySelector(group) {
    var options = group.querySelectorAll('[data-day-option]');
    var summary = group.querySelector('[data-day-summary]');
    var caption = group.querySelector('[data-days-caption]');
    if (!options.length || !summary) return function () { return true; };

    var update = function (revealError) {
      var selected = Array.prototype.filter.call(options, function (option) { return option.checked; });
      var values = selected.map(function (option) { return option.value; });
      summary.value = values.join(', ');
      if (caption) {
        if (values.length === options.length) caption.textContent = 'Any day';
        else if (values.length) caption.textContent = values.join(', ');
        else caption.textContent = 'Choose at least one day';
      }

      var first = options[0];
      var active = !first.disabled && group.hasAttribute('data-days-required');
      first.setCustomValidity('');
      if (active && !values.length) {
        first.setCustomValidity('Choose at least one day.');
        if (revealError) setFieldError(first, 'Choose at least one day.');
        return false;
      }
      clearFieldError(first);
      return true;
    };

    options.forEach(function (option) { option.addEventListener('change', function () { update(true); }); });
    update(false);
    return update;
  }

  function initDateRange(group, todayValue) {
    var start = group.querySelector('[data-range-start]');
    var end = group.querySelector('[data-range-end]');
    if (!start || !end) return function () { return true; };

    var update = function (revealError) {
      end.min = start.value || todayValue;
      end.setCustomValidity('');
      if (!end.disabled && start.value && end.value && end.value < start.value) {
        end.setCustomValidity('Choose an end date on or after the start date.');
        if (revealError) setFieldError(end, 'Choose an end date on or after the start date.');
        return false;
      }
      clearFieldError(end);
      return true;
    };

    start.addEventListener('input', function () { update(true); });
    end.addEventListener('input', function () { update(true); });
    update(false);
    return update;
  }

  function initDateBuilder(form) {
    var builder = form.querySelector('[data-date-builder]');
    if (!builder) return function () { return true; };

    var today = new Date();
    var todayValue = localDateValue(today);
    builder.querySelectorAll('[data-date-min]').forEach(function (field) { field.min = todayValue; });
    builder.querySelectorAll('[data-month-min]').forEach(function (field) { field.min = todayValue.slice(0, 7); });
    builder.querySelectorAll('[data-week-input]').forEach(function (field) { field.min = isoWeekValue(today); });
    builder.querySelectorAll('[data-required-with-js]').forEach(function (field) { field.required = true; });

    var dayUpdaters = [];
    builder.querySelectorAll('[data-day-selector-group]').forEach(function (group) { dayUpdaters.push(initDaySelector(group)); });
    var rangeUpdaters = [];
    builder.querySelectorAll('[data-date-range]').forEach(function (group) { rangeUpdaters.push(initDateRange(group, todayValue)); });

    var dateModes = builder.querySelectorAll('[data-date-mode]');
    var specificDate = builder.querySelector('[data-specific-date]');
    var nearbyToggle = builder.querySelector('[data-nearby-toggle]');
    var nearbyPanel = builder.querySelector('[data-nearby-panel]');
    var flexibilityFields = builder.querySelectorAll('[data-specific-flexibility]');
    var flexibilityOther = builder.querySelector('[data-specific-flexibility-other]');
    var flexibleModes = builder.querySelectorAll('[data-flexible-mode]');
    var weekInput = builder.querySelector('[data-week-input]');
    var weekSummary = builder.querySelector('[data-week-summary]');
    var weekCaption = builder.querySelector('[data-week-caption]');

    var updateWeekdayLabel = function () {
      var label = builder.querySelector('[data-selected-weekday-label]');
      var field = builder.querySelector('[data-specific-flexibility="weekday"]');
      if (!label || !field) return;
      var weekday = '';
      if (specificDate && specificDate.value) {
        weekday = new Date(specificDate.value + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long' });
      }
      label.textContent = weekday ? 'Any ' + weekday + ' either side' : 'Same day of week either side';
      field.value = weekday ? 'Any ' + weekday + ' either side' : 'Same day of week either side';
    };

    var updateSpecificFlexibility = function (nearbyActive) {
      setPanelState(flexibilityOther, nearbyActive && selectedValue(flexibilityFields) === 'Other');
    };

    var updateNearby = function (specificActive) {
      var nearbyActive = specificActive && nearbyToggle && nearbyToggle.checked;
      setPanelState(nearbyPanel, nearbyActive);
      updateSpecificFlexibility(nearbyActive);
    };

    var updateFlexible = function (flexibleActive) {
      var selected = '';
      Array.prototype.forEach.call(flexibleModes, function (field) { if (field.checked) selected = field.dataset.flexibleMode; });
      builder.querySelectorAll('[data-flexible-panel]').forEach(function (panel) {
        setPanelState(panel, flexibleActive && panel.dataset.flexiblePanel === selected);
      });
      dayUpdaters.forEach(function (update) { update(false); });
      rangeUpdaters.forEach(function (update) { update(false); });
    };

    var updateDateMode = function () {
      var selected = '';
      Array.prototype.forEach.call(dateModes, function (field) { if (field.checked) selected = field.dataset.dateMode; });
      builder.querySelectorAll('[data-date-mode-panel]').forEach(function (panel) {
        setPanelState(panel, panel.dataset.dateModePanel === selected);
      });
      updateNearby(selected === 'specific');
      updateFlexible(selected === 'flexible');
      dayUpdaters.forEach(function (update) { update(false); });
      rangeUpdaters.forEach(function (update) { update(false); });
    };

    dateModes.forEach(function (field) { field.addEventListener('change', updateDateMode); });
    if (specificDate) {
      specificDate.addEventListener('input', updateWeekdayLabel);
      specificDate.addEventListener('change', updateWeekdayLabel);
    }
    if (nearbyToggle) nearbyToggle.addEventListener('change', function () { updateNearby(selectedValue(dateModes) === 'Specific date'); });
    flexibilityFields.forEach(function (field) { field.addEventListener('change', function () { updateSpecificFlexibility(!nearbyPanel.hidden); }); });
    flexibleModes.forEach(function (field) { field.addEventListener('change', function () { updateFlexible(selectedValue(dateModes) === 'I’m flexible'); }); });
    if (weekInput && weekSummary) {
      weekInput.addEventListener('input', function () {
        weekSummary.value = weekRange(weekInput.value);
        if (weekCaption) weekCaption.textContent = weekSummary.value || 'Select a week above.';
      });
    }

    updateWeekdayLabel();
    updateDateMode();

    return function (revealError) {
      var valid = true;
      dayUpdaters.forEach(function (update) { if (!update(revealError)) valid = false; });
      rangeUpdaters.forEach(function (update) { if (!update(revealError)) valid = false; });
      if (weekInput && weekSummary) {
        weekSummary.value = weekRange(weekInput.value);
        if (weekCaption) weekCaption.textContent = weekSummary.value || 'Select a week above.';
      }
      return valid;
    };
  }

  function showClientError(form, invalidFields) {
    var summary = form.querySelector('[data-form-client-error]');
    if (!summary) { focusCorrection(invalidFields[0]); return; }
    summary.replaceChildren();
    summary.hidden = false;
    summary.tabIndex = -1;
    var title = document.createElement('p');
    title.textContent = 'Please correct the following ' + invalidFields.length + (invalidFields.length === 1 ? ' item:' : ' items:');
    summary.appendChild(title);
    var list = document.createElement('ul');
    invalidFields.forEach(function (field) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + field.id;
      link.textContent = fieldLabel(field) + ': ' + field.validationMessage;
      link.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); focusCorrection(field); });
      item.appendChild(link);
      list.appendChild(item);
    });
    summary.appendChild(list);
    focusCorrection(summary);
  }

  function clearClientError(form) {
    var summary = form.querySelector('[data-form-client-error]');
    if (summary) {
      summary.hidden = true;
      summary.textContent = '';
    }
  }

  function initForm(form) {
    if (form.dataset.enquiryInitialized === 'true') return;
    form.dataset.enquiryInitialized = 'true';
    form.noValidate = true;

    var phone = form.querySelector('[data-contact-phone]');
    if (phone) {
      phone.addEventListener('input', function () {
        phone.setCustomValidity('');
        var phoneContainer = fieldErrorContainer(phone);
        if (phoneContainer && phoneContainer.querySelector('[data-field-error]')) validateField(phone, true);
      });
    }

    initOtherReveal(form, '[data-act-type]', '[data-other-act-panel]');
    initOtherReveal(form, '[data-event-type]', '[data-other-event-panel]');
    var validateDateBuilder = initDateBuilder(form);

    var socialGroup = form.querySelector('[data-social-links]');
    if (socialGroup) {
      socialGroup.dataset.socialCount = String(socialGroup.querySelectorAll('[data-social-row]').length);
      socialGroup.querySelectorAll('[data-social-input]').forEach(bindSocialInput);
      var addButton = socialGroup.querySelector('[data-add-social-link]');
      if (addButton) addButton.addEventListener('click', function () { addSocialRow(socialGroup, form); });
    }

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.type !== 'radio' && field.type !== 'checkbox') field.setCustomValidity('');
        var container = fieldErrorContainer(field);
        if (container && container.querySelector('[data-field-error]')) validateField(field, true);
      });
      field.addEventListener('blur', function () {
        if (field.type !== 'radio' && field.type !== 'checkbox') validateField(field, true);
      });
      field.addEventListener('change', function () {
        if (field.type === 'radio' && field.name) {
          form.querySelectorAll('input[type="radio"]').forEach(function (radio) {
            if (radio.name === field.name) {
              radio.setCustomValidity('');
              clearFieldError(radio);
            }
          });
        }
      });
      field.addEventListener('invalid', function (event) {
        event.preventDefault();
      });
    });

    form.addEventListener('submit', function (event) {
      clearClientError(form);
      validateDateBuilder(true);
      var invalidFields = [];
      var groups = new Set();
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (field.disabled || field.type === 'hidden') return;
        if (field.type === 'radio') {
          if (groups.has(field.name)) return;
          groups.add(field.name);
        }
        if (!validateField(field, true)) invalidFields.push(field);
      });
      if (invalidFields.length) {
        event.preventDefault();
        showClientError(form, invalidFields);
      }
    });
  }

  function init(root) {
    var forms = root.matches && root.matches('.enquiry-form') ? [root] : root.querySelectorAll('.enquiry-form');
    forms.forEach(initForm);
  }

  window.FAEnquiryForms = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
